// extracted by mini-css-extract-plugin
export default {"container":"kUPz5B","mobileBanner":"ZuQS2l","bg":"XpvVrO","content":"Z740pZ","link":"z4w3yd","light":"eFk0xl","button":"qOG1FE","description":"ZsE0zx"};